import { DeductableMaster, RepairTypeMaster } from './BindMdl';

export class mdlBindInfoUpgradeRes {

    public PolicyNo: string;
    public RegNo: string;
    public Insured_IdNo: string;
    public InsuredName: string;
    public VehicleDefType: string;
    public SequenceNo: string;
    public CustomNo: string;
    public deductableList: Array<DeductableMaster> = new Array<DeductableMaster>();
    public repairList: Array<RepairTypeMaster> = new Array<RepairTypeMaster>();
    public SumInsured: number;
    public StatusCode: string;
    public ErrorMsg: string;
    public DeductableType: string;
    public RepairType: number;
    public MaxSumInsured: number;
    public MinSumInsured: number;

    public Model_En: string;
    public Model_Ar: string;
    public Make_En: string;
    public Make_Ar: string;

    public Vehicle_PlateNo: string;
    public Vehicle_Fletter_Ar: string;
    public Vehicle_Fletter_En: string;
    public Vehicle_Sletter_Ar: string;
    public Vehicle_Sletter_En: string;
    public Vehicle_Tletter_Ar: string;
    public Vehicle_Tletter_En: string;
    public VehicleId: string;
    public ChassisNo: string;


}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfoUpgradeRes.ts